import { defineNuxtRouteMiddleware } from '#app'
import { getValue, fetchAndActivate } from 'firebase/remote-config'

export default defineNuxtRouteMiddleware(async (to) => {
  // Only run on client side
  if (import.meta.server) return
  
  // Skip if already on maintenance page
  if (to.path === '/maintenance') return

  try {
    // Get Firebase Remote Config
    const { $firebaseRemoteConfig } = useNuxtApp()
    
    if (!$firebaseRemoteConfig) {
      console.warn('Firebase Remote Config not available - continuing normally')
      return
    }

    // Fetch latest config (with caching)
    await fetchAndActivate($firebaseRemoteConfig)
    
    // Check maintenance mode flag
    const maintenanceMode = getValue($firebaseRemoteConfig, 'maintenance_mode')
    
    if (maintenanceMode.asBoolean()) {
      console.log('Maintenance mode is ACTIVE - redirecting to maintenance page')
      return navigateTo('/maintenance')
    }
    
  } catch (error) {
    console.error('Error checking maintenance mode:', error)
    // Continue normally if there's an error
  }
})
